@if (navigation.hasHistory() || url !== undefined) {
  <button
    (click)="onClick()"
    class="block lg:hidden pr-3 text-base/3 text-[--primary-600] hover:text-[--primary-500]"
    [ngClass]="{ 'lg:hidden': url === undefined }"
    aria-label="Ga terug"
  >
    <mat-icon>arrow_back</mat-icon>
  </button>
}
